<template>
  <DaiTarjetaContenedorMapa
    class="fix"
    :es-version-escritorio-en-pantalla-larga="true"
    altura-colapsada="560px"
    etiqueta-colapso="Más información"
    etiqueta-no-colapso="Menos información"
  >
    <Loader v-if="!cargaLista" />

    <template #header>
      <h3 v-width-control="'100%'">Uso de maquinaria 2007</h3>
      <p>Haz clic sobre el estado para ver información a nivel municipal</p>
    </template>

    <DaiMapa
      ref="mapa"
      class="canvas-container-mapa"
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]"
      :niveles="['x-estados','x-municipios']"
      @reset_view="resetMap"
      @cambioNivel="cambionivel"
      :nivelActual.sync="nivelActual"
    >
      <DaiCapaXyz />

      <DaiCapaGeojson
        :key="`centroides_maquinaria_${actualizador}`"
        :id="`centroides_maquinaria_${actualizador}`"
        :datos="{type: 'FeatureCollection', features: centroides_actuales}"
        titulo="Maquinas"
        :z-index="3"
        :reglas-estilo-capa="[
          {
            clasificacion: 'categorias',
            columna: 'maquinaria',
            propiedadObjetivo: 'relleno',
            colores: ['#96214099','#C246BF99','#FE7F0099'],
            acomodoCategorias: ['Motogrúas','Trilladoras','Otras']
          },{
            clasificacion: 'personalizada',
            propiedadObjetivo: 'proporcion',
            columna: 'maquinaria_v',
            clasificacionPersonalizada: clasesMaquinas[nivelActual],
            proporciones: [3,6,9,12],
            clases: 4,
            tituloVariable: 'Cantidad de máquinas'
          }
        ]"
        :estilo-capa="{
          stroke:{color:'red', width: 1}
        }"
      />

      <DaiCapaGeojson
        :key="`poligonos_maquinaria_${actualizador}`"
        :id="`poligonos_maquinaria_${actualizador}`"
        :datos="{type: 'FeatureCollection', features: poligonos_actuales}"
        :z-index="2"
        :reglas-estilo-capa="[
          {
            clasificacion: 'personalizada',
            propiedadObjetivo: 'relleno',
            columna: 'tot_tract',
            clasificacionPersonalizada: clasesTractores[nivelActual],
            colores: ['#fffb9b','#ffeb00','#d6c603'],
            clases: 3
          },
        ]"
        :estilo-capa="{
          stroke: {color: 'green', width: .2}
        }"
        @click_feature="clickEstado"
        :contenidoTooltip="contenidoTooltip"
      />
      <!--poligonos para el tooltip cuando se apagan los poligonos de la coropleta-->
      <DaiCapaGeojson
        :key="`poligonos_base_${actualizador}`"
        :id="`poligonos_base_${actualizador}`"
        :datos="{type: 'FeatureCollection', features: poligonos_actuales}"
        :z-index="1"
        
        :estilo-capa="{
          stroke: {color: 'lightgray', width: .5},
          fill: {color:'transparent'}
        }"
        @click_feature="clickEstado"
        :contenidoTooltip="contenidoTooltip"
      />
      <!--Capa de estados solo de contorno en la vista municipal-->
      <DaiCapaGeojson
        :id="`poligonos_estados`"
        :datos="{type: 'FeatureCollection', features: [...poligonos_edos]}"
        :z-index="5"
        :estilo-capa="{
          stroke: {color: 'black', width: 1},
        }"
        :zoom-al-dar-click="false"
        :visible="nivelActual==='x-municipios'"
      />
    </DaiMapa>

    <template #footer>
      <!-- Dado que el componente no cuenta con esta curva, actualmente la version de daimaps es v0.1.13, 
        si se actualiza la version de dai-maps se debe revisar si ya lo trae, 
        ya que podria encimarce con esta que esta adecuada solo para este proyecto
      -->
      <div class="curva-flotante">
        <div></div>
      </div>

      <div v-width-control="'100%'">
        <button class="dai-map-button control-small boton-ver-municipios"
        @click="verPorMunicipios">
          {{nivelActual==="x-estados"? 'Ver por municipios': 'Ver por estado'}}
        </button>
      </div>

      <DaiLeyendaMapa class="leyenda-reverse"
        :key="`centroides_maquinaria_${actualizador}`"
        :para="`centroides_maquinaria_${actualizador}`"
        titulo="Máquinas"
        :mostrar-boton-alterna-todos="true"
      />

      <hr class="dai-map-separator thin">

      <DaiLeyendaMapa
        :key="`poligonos_maquinaria_${actualizador}`"
        :para="`poligonos_maquinaria_${actualizador}`"
        titulo="Unidades de producción con uso de tractor"
        :mostrar-boton-alterna-todos="true"
      />

      <hr class="dai-map-separator thin">
        
      <div class="dai-map-notes">
        <p>
          Muestra información a nivel estatal y municipal sobre la maquinaria utilizada para el trabajo agrícola. Se visualizan las categorías de "Motogrúas", "Trilladoras" y "Otros" en cantidades de máquinas. La categoría "Otros" contiene 99 diferentes tipos de máquinas, por ejemplo: aspersoras, compresoras, desmalezadoras, empacadoras, motosierras, entre otras. Así mismo, se muestran las unidades de producción con uso de tractor, no debe confundirse con número de tractores.
        </p>
        <p>
          <b>Fuente:</b> INEGI, Censo Agrícola, Ganadero y Forestal 2007.
        </p>
      </div>

      <hr class="dai-map-separator thin">
      <a class="dai-map-button download" :href="`${cdnArchivos}/cultivos_uso_maquinaria.zip`" download>
        Descargar datos
      </a>
    </template>
  </DaiTarjetaContenedorMapa>
</template>

<script>
import {reducerMaquinariaCentroides} from './_preparaDatosMaquinaria.js'
import { leerGeoJSON } from './_utils.js'
import Loader from '@/components/utiles/Loader.vue'

/*
--Municipal--
Uso maquinaria (Bug - Al quitar todos una capa se queda prendida)

Uso de tractor(Bug - Al quitar todos una capa se queda prendida)
*/

const rutaDatos = '../data/mapa-maquinaria'

export default {
  data() { return {
    centroides_edos: [],
    centroides_muns: [],
    centroides_actuales: [], //capa que va guardando los datos que se van filtrando segun los niveles
    capasCentroidesActivas: [], //array con index para actualizar en la vista los filtros activos (falta complementar la libreria para que un componente tenga esta funcionalidad )
    poligonos_edos: [],
    poligonos_muns: [],
    poligonos_actuales: [],
    capasPoligonosActivas: [],
    nivelActual: "x-estados",

    cargaLista: false,
    clasesMaquinas: {
      "x-estados": [[1,500],[500,1500],[1500,5000],[5000,10200]],
      "x-municipios": [[1,50],[50,300],[300,1000],[1000,3070]],
    },
    clasesTractores: {
      "x-estados": [[1800,25000],[25000,75000],[75000,175100]],
      "x-municipios": [[3,200],[200,2000],[2000,13730]],
    },
    actualizador: 0,
    cdnArchivos:  `${process.env.VUE_APP_CDN_ARCHIVOS}/alternativas/practicas-especiales-mapa`,
  }},
  mounted () {
    leerGeoJSON(`${rutaDatos}/capa_mapa2_maquinaria_edos2020_centroides.geojson`)
      .then(data=>{
        this.centroides_edos = reducerMaquinariaCentroides(data,false)
        this.centroides_actuales = [...this.centroides_edos]
        leerGeoJSON(`${rutaDatos}/centroides_mapa2_maquinaria_mgn2020.geojson`)
          .then(data2=>{
            this.centroides_muns = reducerMaquinariaCentroides(data2,false)
            this.actualizarCapasCentroidesEnMapa()
          })
      })
    
    leerGeoJSON(`${rutaDatos}/capa_mapa2_maquinaria_edos2020.geojson`)
      .then(data=>{
        this.poligonos_edos = data.features
        this.poligonos_actuales = [...this.poligonos_edos]
        leerGeoJSON(`${rutaDatos}/capa_mapa2_maquinaria_mgn2020.geojson`)
          .then(data2=>{
            this.poligonos_muns = data2.features
            this.actualizarCapasPoligonosEnMapa()
            setTimeout(()=>{
              this.$refs.mapa.forceResizeMap(true)
              this.cargaLista = true
            },500)
          })
      })
  },
  methods:{
    actualizarCapasCentroidesEnMapa() {
      //console.log(this.centroides_actuales)
      if(this.capasCentroidesActivas.length === 0){
        this.capasCentroidesActivas.push({id:0})
        return
      }
      this.capasCentroidesActivas[0].id++
      
    },
    actualizarCapasPoligonosEnMapa() {
      //console.log(this.centroides_actuales)
      if(this.capasPoligonosActivas.length === 0){
        this.capasPoligonosActivas.push({id:0})
        return
      }
      this.capasPoligonosActivas[0].id++
      
    },
    clickEstado([feature]){
      if(this.nivelActual==="x-estados"){
        this.cargaLista = false
        const cvegeo =feature.getProperties()["cvegeo"].substring(0,2)
      
        this.poligonos_actuales = this.poligonos_muns
          .filter(poligono=>poligono.properties["cve_ent"]=== cvegeo)
        this.centroides_actuales = this.centroides_muns
          .filter(centroide=>centroide.properties["cve_ent"]=== cvegeo)
        this.actualizarCapasPoligonosEnMapa()
        this.actualizarCapasCentroidesEnMapa()
        this.$refs.mapa.setNivel("x-municipios")

        this.actualizador++
        this.cargaLista = true
      }
    },
    resetMap(){
      this.poligonos_actuales = this.poligonos_edos;
      this.centroides_actuales = this.centroides_edos
      this.actualizarCapasPoligonosEnMapa()
      this.actualizarCapasCentroidesEnMapa()
      this.actualizador++
    },
    cambionivel(newNivel){
      if(newNivel==="x-estados"){
        this.$refs.mapa.external_force_reset_view()
        this.resetMap()
      }
    },
    verPorMunicipios(){
      if(this.nivelActual==="x-estados"){
        this.poligonos_actuales = [...this.poligonos_muns]
        this.centroides_actuales = [...this.centroides_muns]
        this.actualizarCapasPoligonosEnMapa()
        this.actualizarCapasCentroidesEnMapa()
        this.$refs.mapa.setNivel("x-municipios")
      }else{
        this.$refs.mapa.resetMap()
      }
      this.actualizador++
    },
    contenidoTooltip(f){
      return `<b>${f.nomgeo? f.nomgeo : f.nom_mun}</b><br>
        <span class="renglon-tooltip">
          <span class="indicador-tooltip" style="background-color:#96214099"></span>
          Motogrúas: ${f.maq_motog!=null? f.maq_motog.toLocaleString("en"): "Sin dato"}
        </span><br><span class="renglon-tooltip">
          <span class="indicador-tooltip" style="background-color:#C246BF99"></span>
          Trilladoras: ${f.maq_trilla!=null? f.maq_trilla.toLocaleString("en"): "Sin dato"}
        </span><br><span class="renglon-tooltip">
          <span class="indicador-tooltip" style="background-color:#FE7F0099"></span>
          Otras maquinarias: ${f.otra_maq!=null? f.otra_maq.toLocaleString("en"): "Sin dato"}
        </span><br><br><span class="renglon-tooltip">
          Unidades de producción <br> con uso de tractor: ${f.tot_tract!=null
            ? f.tot_tract.toLocaleString("en"): "Sin dato"}</span>`
    }
  },
  components: {
    Loader,
  },
}
</script>


<style lang="scss">
  .fix {
    overflow: hidden;
    margin-bottom: $gap;
  }
  a.dai-map-button.download{
    display: block;

    &:hover,&:focus{
      background-color: #000;
      box-shadow: none;
      color: #fff;
    }
  }
</style>